var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Dropdown",
    {
      ref: "dropdown",
      staticClass: "bulk-actions-dropdown pull-right column-toggle",
      attrs: { tag: "span", "menu-right": true, "not-close-elements": _vm.ele }
    },
    [
      _c("button", [_c("span", { staticClass: "typcn typcn-cog" })]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "dropdown" },
        _vm._l(_vm.tempColumnSettings, function(setting) {
          return _c("li", { key: setting.displayName }, [
            _c("div", { staticClass: "menu-item" }, [
              _c("input", {
                staticClass: "m-r-4",
                attrs: {
                  id: setting.name,
                  type: "checkbox",
                  name: setting.name
                },
                domProps: { checked: !setting.hide },
                on: {
                  change: function($event) {
                    return _vm.saveColumnVisibility(setting)
                  }
                }
              }),
              _vm._v(" "),
              _c("label", {
                attrs: { for: setting.name },
                domProps: { textContent: _vm._s(_vm.$t(setting.displayName)) }
              })
            ])
          ])
        }),
        0
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }